import { createClassNameModifier } from '@bem-react/core';
import './Calendar_size_l.css';
export var withSizeL = createClassNameModifier('Calendar', { size: 'l' });
